// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setModuleFilters = createAction('[Custom PDF Report Builder] Set Module Filters', props());
